export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["l"] = "l";
    ButtonSize["m"] = "m";
    ButtonSize["s"] = "s";
})(ButtonSize || (ButtonSize = {}));
export var ButtonTheme;
(function (ButtonTheme) {
    ButtonTheme["primary"] = "primary";
    ButtonTheme["business"] = "business";
    ButtonTheme["secondary"] = "secondary";
    ButtonTheme["tertiary"] = "tertiary";
    ButtonTheme["validation"] = "validation";
    ButtonTheme["navigationReset"] = "dimgray-ghost";
    ButtonTheme["download"] = "download";
})(ButtonTheme || (ButtonTheme = {}));
